'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageAvatarWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageAvatar__PrimaryMessageAvatarWrapper",
  componentId: "sc-1vumaek-0"
})(["align-items:center;display:flex;flex-shrink:0;justify-items:center;margin-top:35px;"]);
export default class PrimaryMessageAvatar extends PureComponent {
  render() {
    const {
      children,
      className
    } = this.props;
    return /*#__PURE__*/_jsx(PrimaryMessageAvatarWrapper, {
      "data-test-id": "primary-message-avatar",
      className: className,
      children: children
    });
  }
}
PrimaryMessageAvatar.displayName = 'PrimaryMessageAvatar';
PrimaryMessageAvatar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};